import { postAdapter } from '@/Module/Post/Store/Adapter';
import type { IState } from '@/Module/Store/Model';

export const { selectAll: postSelectAll } = postAdapter.getSelectors<IState>(state => state.post);
